export default "__VITE_ASSET__DZY9QO$v__"